import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    }
  },
  timeDurationRow: {
    paddingBottom: '24px',
    marginBottom: '24px',
    borderBottom: '1px solid #e2ebf6',
    '&:last-child': {
      paddingBottom: 0,
      marginBottom: 0,
      border: 0,
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '16px',
      marginBottom: '16px',
    }
  },
  deleteIcon: {
    fontSize: '23px',
    marginTop: '15px',
    color: '#59758B',
    [theme.breakpoints.down('sm')]: {
      marginTop: '10px',
      fontSize: '20px',
    }
  },
  buttonsGroup: {
    width: '195px',
    marginBottom: '13px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '10px',
      mrrginLeft : '20px'
    }
  },
  timePickerWrapper: {
    width: '150px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '10px',
    }
  },
  inputWrapper: {
    width: '75px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '10px',
    }
  },
  dropDownWrapper: {
    width: '210px',
    marginTop: '17px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: '10px',
    }
  }
}));
